import React__default from 'react';
import { CopyableTextCore } from '../shared/components/CopyableText.mjs';
import { useClickToCopy } from '../utils/clickToCopyUtils.mjs';
import { Code } from './Code.mjs';
import { Label } from './Label.mjs';
import { Typography } from './Typography.mjs';

const wrapperSx = (theme)=>({
        backgroundColor: theme.styleConfig.colors.accent
    });
const CopyableText = (props)=>{
    return /*#__PURE__*/ React__default.createElement(CopyableTextCore, {
        ...props,
        CodeComponent: Code,
        LabelComponent: Label,
        TypographyComponent: Typography,
        useClickToCopy: useClickToCopy,
        wrapperSx: wrapperSx
    });
};

export { CopyableText };
//# sourceMappingURL=CopyableText.mjs.map
